import { PropsWithChildren, useCallback } from 'react';
import { MdOutlineEvent } from 'react-icons/md';
import { startOfToday } from 'date-fns';
import { Button } from '@ds';
import { ScheduleDateControl } from './components';

type SchedulerDateNavigationSectionProps = PropsWithChildren<{
  selectedDate: Date;
  onDateChange: (date: Date) => void;
}>;

export const SchedulerDateNavigationSection = ({
  selectedDate,
  onDateChange,
  children,
}: SchedulerDateNavigationSectionProps) => {
  const onTodayClick = useCallback(() => onDateChange(startOfToday()), [onDateChange]);

  return (
    <div className="flex items-center gap-4">
      <Button
        disableRipple
        size="sm"
        variant="outline"
        className="px-3"
        startContent={<MdOutlineEvent />}
        onClick={onTodayClick}
      >
        Today
      </Button>
      <ScheduleDateControl value={selectedDate} onChange={onDateChange} />
      {children}
    </div>
  );
};
